<div *ngIf="isOpen" class="relative z-[100]" aria-labelledby="modal-title" role="dialog" aria-modal="true" tabindex="-1" cdkTrapFocus
    [cdkTrapFocusAutoCapture]="isOpen">
    <div [@backdropAnimation]="isOpen" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div [@modalPanelAnimation]="isOpen"
                class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">


                <div>
                    <img (click)="closeModal()" src="assets/images/svgs/x-close.svg" alt="Icon to Delete Uploaded Document"
                        class="absolute top-4 right-4 h-5 w-5 cursor-pointer" />

                    <div class="mt-3 sm:mt-5">
                        @if (currentSection === 'setup') {
                            <h3 class="text-2xl font-extrabold text-mango-gray900 mb-2">Setup 2-factor authentication</h3>
                            <p>Scan the QR code below with your microsoft authenticator app on your phone</p>
                            <div class="flex justify-center my-4">
                                <img src="{{ qrCodeUrl }}"
                                    alt="2FA QR Code">
                            </div>
                        }

                        <form [formGroup]="twoFactorForm">
                            <h3 class="text-2xl font-extrabold text-mango-gray900 mb-2">Enter verification code</h3>
                            <app-input-label labelClass="label--bottom-margin">Enter verification code from
                                authentication app</app-input-label>
                            <app-input placeholder="Enter the six-digit code" inputClass="input--padding"
                                formControlName="OTP"></app-input>

                            <button (click)="verify2FA()" type="button" mango-button [disabled]="(isLoading$ | async) || twoFactorForm.invalid"
                                class="mt-5 w-full justify-center">
                                @if (isLoading$ | async) {
                                    <span spin></span>
                                } @else {
                                    <span>Verify</span>
                                }
                            </button>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>